module.exports = __webpack_public_path__ + "img/extended.bfcf8b3c.png";